import { 
    GET_ALL_VENDING_MACHINES,
    GET_VENDING_MACHINE,
    ADD_VENDING_MACHINE,
    UPDATE_VENDING_MACHINE,
    DELETE_VENDING_MACHINE,
    GET_VENDING_MACHINE_STOCK,
    GET_REGIONS,
    VENDING_MACHINE_REGISTRATION,
    LIST_REGISTERED_VENDING_MACHINE,
    AVAILABLE_VENDING_MACHINE,
    REGISTERED_VENDING_MACHINE,
    VENDING_MACHINE_LOADING
} from '../actions/types';

const initialState ={
    vendingMachine: null,
    vendingMachines: [],
    loading: true,
    getVendingMachinesStock: [],
    getregions: [],
    stockInfo: {},
    registrationList: null,
    registeredVMList: null,
    registeredVendingMachine: null,
    vendingMachinesForRegistration: []
}

const vendingMachineReducer = ( state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ALL_VENDING_MACHINES:
            return {
                ...state,
                vendingMachines: payload,
                loading: false
            };
        case GET_VENDING_MACHINE:
            return{
                ...state,
                vendingMachine: payload,
                loading: false
            };
        case ADD_VENDING_MACHINE:
            return {
                ...state,
                vendingMachines: payload,
                loading: false
            };
        case UPDATE_VENDING_MACHINE:
            return {
                ...state,
                vendingMachine: payload
            };
        //state.vendingMachines.filter(vm => vm._id !== payload),
        case DELETE_VENDING_MACHINE:
            return {
                ...state,
                vendingMachines: payload,
                loading: false
            };
        case GET_VENDING_MACHINE_STOCK:
            return {
                ...state,
                stockInfo : payload
            };
        case GET_REGIONS:
            return {
                ...state,
                getregions : payload
            };
        case VENDING_MACHINE_LOADING:
            return {
                ...state,
                loading: true
            };
        case VENDING_MACHINE_REGISTRATION:
            return {
                ...state,
                registrationList : payload
            };
        case LIST_REGISTERED_VENDING_MACHINE:
            return {
                ...state,
                registeredVMList : payload
            };
        case REGISTERED_VENDING_MACHINE:
            return {
                ...state,
                registeredVendingMachine : payload
            };
        case AVAILABLE_VENDING_MACHINE:
            return {
                ...state,
                vendingMachinesForRegistration : payload
            };
        default:
            return state;
    }
};

export default vendingMachineReducer;